<template>
    <div :dusk="props.dusk">
        <div v-for="(value, key) in object" :key="key">
            <div v-if="typeof value === 'object'" class="flex">
                <!-- Key -->
                <div v-if="typeof key === 'number'" class="self-center font-bold">[]</div>
                <div v-else class="font-bold">{{ key }}</div>

                <!-- Value -->
                <div class="ml-4">
                    <json-view :json="JSON.stringify(value)" class="ml-4" />
                </div>
            </div>

            <div v-else class="flex">
                <!-- Key -->
                <div v-if="typeof key === 'number'" class="self-center font-bold">[]</div>
                <div v-else class="font-bold">{{ key }}</div>

                <!-- Value -->
                <div class="ml-4">{{ value }}</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    dusk?: string | null;
    json?: string;
}

const props = withDefaults(defineProps<Props>(), {
    dusk: null,
    json: null,
});

const object = computed(() => {
    if (!props.json) {
        return null;
    }

    return JSON.parse(props.json);
});
</script>
